// get one app instance
export const FLAG_GETTING_APP_INSTANCE = 'FLAG_GETTING_APP_INSTANCE';
export const GET_APP_INSTANCE_SUCCEEDED = 'GET_APP_INSTANCE_SUCCEEDED';
export const GET_APP_INSTANCE_FAILED = 'GET_APP_INSTANCE_FAILED';
export const GET_APP_INSTANCE = 'GET_APP_INSTANCE';

// update one app instance
export const FLAG_PATCHING_APP_INSTANCE = 'FLAG_PATCHING_APP_INSTANCE';
export const PATCH_APP_INSTANCE_SUCCEEDED = 'PATCH_APP_INSTANCE_SUCCEEDED';
export const PATCH_APP_INSTANCE_FAILED = 'PATCH_APP_INSTANCE_FAILED';
export const PATCH_APP_INSTANCE = 'PATCH_APP_INSTANCE';
